// extracted by mini-css-extract-plugin
export var alternate = "_1k-j";
export var black = "_1k-6";
export var blue = "_1k-f";
export var blueLight = "_1k-e";
export var brand = "_1k-8";
export var darkMode = "_1k-b";
export var error = "_1k-a";
export var gray = "_1k-5";
export var grayBlue = "_1k-d";
export var iconWrapper = "_1k-3";
export var inactive = "_1k-7";
export var indigo = "_1k-g";
export var orange = "_1k-i";
export var pink = "_1k-h";
export var primary = "_1k-0";
export var purple = "_1k-9";
export var success = "_1k-4";
export var warning = "_1k-c";
export var white = "_1k-1";
export var whiteSuccess = "_1k-2";